export type EmojiCategory = {
  id: string
  name: string
  icon: string
  emojis: string[]
}

export const EMOJI_CATEGORIES: EmojiCategory[] = [
  {
    id: 'transport',
    name: 'Транспорт',
    icon: '🚗',
    emojis: [
      '🚗',
      '🚕',
      '🚙',
      '🚌',
      '🚎',
      '🏍️',
      '🚓',
      '🚑',
      '🚒',
      '🚐',
      '🚚',
      '🚛',
      '🚜',
      '🚲',
      '🛴',
      '🛵',
      '🏎️',
      '🛺',
      '🚁',
      '🚖',
      '🚀',
      '🛸',
      '🚤',
      '⛽',
      '🚋',
      '🚂',
      '✈️',
      '⛵',
      '🛶',
      '🚡'
    ]
  },
  {
    id: 'smileys',
    name: 'Смайлы',
    icon: '🙂',
    emojis: [
      '😀',
      '😃',
      '😄',
      '😁',
      '😅',
      '😂',
      '🙂',
      '😉',
      '😊',
      '😍',
      '😘',
      '😜',
      '🤔',
      '😐',
      '😑',
      '😴',
      '😷',
      '🤒',
      '😎',
      '🥳',
      '😢',
      '😭',
      '😡',
      '😱',
      '🤗',
      '🤝',
      '👍',
      '👎',
      '👏',
      '🙏'
    ]
  },
  {
    id: 'people',
    name: 'Люди',
    icon: '👤',
    emojis: [
      '👤',
      '👶',
      '🧒',
      '👦',
      '👧',
      '🧑',
      '👨',
      '👩',
      '🧓',
      '👴',
      '👵',
      '👮',
      '👷',
      '💼',
      '🔧',
      '🍳',
      '🌾',
      '🏫',
      '🏠',
      '👪',
      '🤵',
      '👰',
      '🎅',
      '⚕️',
      '🔍',
      '💪',
      '🖐️',
      '✌️',
      '👋',
      '🦺'
    ]
  },
  {
    id: 'animals',
    name: 'Животные',
    icon: '🐞',
    emojis: [
      '🐞',
      '🐝',
      '🐛',
      '🦋',
      '🐌',
      '🕷️',
      '🐶',
      '🐱',
      '🐭',
      '🐹',
      '🐰',
      '🦊',
      '🐻',
      '🐼',
      '🐨',
      '🐯',
      '🦁',
      '🐮',
      '🐷',
      '🐸',
      '🐵',
      '🐔',
      '🐧',
      '🐦',
      '🐴',
      '🦄',
      '🐢',
      '🐬',
      '🐳',
      '🌳'
    ]
  },
  {
    id: 'symbols',
    name: 'Символы',
    icon: '⭐',
    emojis: [
      '⭐',
      '🌟',
      '✨',
      '⚡',
      '🔥',
      '💧',
      '❤️',
      '🧡',
      '💛',
      '💚',
      '💙',
      '💜',
      '✅',
      '❌',
      '❗',
      '❓',
      '⚠️',
      '🔒',
      '🏠',
      '🏢',
      '🔑',
      '🛠️',
      '🧰',
      '🔧',
      '📅',
      '📌',
      '📎',
      '📞',
      '💡',
      '🎁'
    ]
  }
]
